export default "__VITE_ASSET__Br7lBAUC__"